import { Link as NbLink } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Link = NbLink;

export default addWithConfig(Link);
